import { GENERAL_CONFIRMATION } from '@components/App/SystemDialogs/constants'
import { openSystemDialog } from '@storeOld/reducers/ui'
import type { Action } from 'redux'
import { all, put, select, takeEvery } from 'redux-saga/effects'

import { InternalConfirmActions, OpenConfirmation } from './actions'
import { confirmedActionsSelector } from './selectors'

function* submit() {
  const actions: Action[] = yield select(confirmedActionsSelector)
  yield all(actions.map((action) => put(action)))

  yield put(InternalConfirmActions.clear())
}

function* open({ payload }: ReturnType<typeof OpenConfirmation>) {
  yield put(InternalConfirmActions.set(payload))

  yield put(openSystemDialog(GENERAL_CONFIRMATION))
}

export function* confirmationSaga() {
  yield all([
    takeEvery(InternalConfirmActions.submit, submit),
    takeEvery(OpenConfirmation, open),
  ])
}
